export default "__VITE_ASSET__827c63b4__"